import consultationRequestAPI from '../../api/consultation_request'
import consultationAPI from '../../api/consultation'
import customerApi from '../../api/customer/profile'
import medicationsAPI from '../../api/customer/medication'
import ably from '../../core/ably'
import StoreInit from '../../api/initialise_store'
import prescriptionAPI from '../../api/customer/prescription'
import HealthParameters from '../../api/customer/health_parameters'
import summary from '../../api/customer/summary'
import labDocument from '../../api/customer/document'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'
import moment from 'moment'
import {convertHeightToFeetInches} from '../../components/common/snackbar/helpers'
import * as Sentry from '@sentry/vue'
Vue.use(VueToast)

// State
const state = {
  initiated: false,
  activeConsults: [],
  activeCustomerId: null,
  activeChannelId: null,
  messages: [],
  inputMessage: '',
  selectedTests: [],
  selectedDrugs: [],
  drugs: []
}
// Getters
const getters = {
  getActiveConsults () {
    return state.activeConsults
  },

  getActiveUserProfile () {
    let consult = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    if (consult) {
      return consult
    }
    return {}
  },

  isActiveChatPresent () {
    if (state.activeChannelId !== null) {
      return true
    } else {
      return false
    }
  },

  activeConsultsCount () {
    return state.activeConsults.length
  },

  getInputMessage () {
    let index = state.messages.findIndex((msg) => msg.channelId === state.activeChannelId)
    let message = ''
    if (index === -1) {
      state.inputMessage = ''
      message = ''
    } else {
      state.inputMessage = state.messages[index].message
      message = state.messages[index].message
    }
    // Logging for jumbled messages in production
    // Temporary code to capture the input message
    if (state.activeChannelId !== state.activeCustomerId && message.length > 0) {
      let maskedMessage = ''
      maskedMessage = '*'.repeat(Math.max(0, message.length - 4)) + message.slice(-4)
      Sentry.setUser({ id: state.activeChannelId })
      Sentry.captureMessage('Input Message', {
        level: 'info',
        tags: { event_name: 'input_message' },
        extra: {
          msgChannelId: message.channelId,
          activeChannelId: state.activeChannelId,
          index: index,
          message: maskedMessage,
          activeCustomerId: state.activeCustomerId
        }
      })
    }

    return message
  },

  getLabTests () {
    let index = state.selectedTests.findIndex((test) => test.customerId === state.activeCustomerId)
    if (index > -1) {
      return state.selectedTests[index].tests
    } else {
      return []
    }
  },

  getIsAdding () {
    let index = state.selectedDrugs.findIndex((drug) => drug.customerId === state.activeCustomerId)
    if (index > -1) {
      return state.selectedDrugs[index].isAdding
    } else {
      return false
    }
  },

  getDrugs () {
    let index = state.drugs.findIndex((ele) => ele.customerId === state.activeCustomerId)
    if (index > -1) {
      return state.drugs[index].drugs
    } else {
      return []
    }
  },

  getCurrentDrug () {
    let index = state.selectedDrugs.findIndex((drug) => drug.customerId === state.activeCustomerId)
    if (index > -1) {
      return state.selectedDrugs[index].drugs
    } else {
      let medication = {
        name: null,
        dose_quantity: '',
        dose_unit: '',
        frequency: null,
        frequency_unit: null,
        date: null,
        duration: null,
        duration_unit: null,
        number_of_days: 0,
        isActive: true,
        route: null,
        instructions: null,
        is_current: false
      }
      return medication
    }
  }
}

// Actions
const actions = {
  init ({commit, state, dispatch, rootState}) {
    StoreInit.fetchActiveConsultationsDetails().then(response => {
      if (response.status === 200) {
        commit('setUpDetails', response.body.active_consultations)
        dispatch('message/setUpAllPatientMessages', {}, {root: true})
        if (state.activeConsults.length > 0) {
          dispatch('switchTo', {channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId})
        } else {
          dispatch('switchTo', {channelId: null, customerId: null})
        }
      }
    })
  },

  addToActiveConsultation ({ commit, state, dispatch }, { request, consultation }) {
    commit('addToActiveConsults', { request, consultation })
    dispatch('joinCustomerChannel', request.channelId)
    dispatch('switchTo', {channelId: request.channelId, customerId: request.customer_id, isNewPatient: true})
  },

  addQueryToActiveConsultation ({ commit, state, dispatch }, { request, consultation }) {
    commit('addQueryToActiveConsults', { request, consultation })
    dispatch('joinCustomerChannel', request.channelId)
    dispatch('switchTo', {channelId: request.channelId, customerId: request.customer_id})
  },

  removeConsultation ({commit, state}, customerId) {
    commit('remove', customerId)
    if (state.activeConsults.length > 0) {
      commit('switchTo', {channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId})
    } else {
      commit('switchTo', {channelId: null, customerId: null})
    }
    ably.updatePresenceEvents(customerId, 'leave')
  },

  joinCustomerChannel ({state}, channelId) {
    ably.subscribeToChannel(channelId)
  },

  endChat ({commit, state, rootState, dispatch}, {status, reasons, id}) {
    let patient
    if (id) {
      patient = state.activeConsults.find(function (ele) {
        return (ele.channelId === id)
      })
    } else {
      patient = state.activeConsults.find(function (ele) {
        return (ele.channelId === state.activeChannelId)
      })
    }
    let channelId = patient.channelId
    if (status === 'SUCCESS') {
      consultationRequestAPI.end(patient.consultationRequest.consultationRequestId).then(response => {
        if (response.status === 200 || response.status === 204) {
          if (response.body.message === 'Diagnosis can not be empty') {
            Vue.$toast.open({
              message: 'Diagnosis can not be empty',
              type: 'error',
              position: 'top',
              queue: false
            })
          } else if (response.body.status === 'error') {
            Vue.$toast.open({
              message: response.body.message,
              type: 'error',
              position: 'top',
              queue: false
            })
            commit('remove', channelId)
            commit('switchTo', {channelId: null, customerId: null})
          } else {
            commit('remove', channelId)
            commit('removeDrugs', {customerId: patient.customerId})
            if (state.activeConsults.length > 0) {
              commit('switchTo', {channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId})
            } else {
              commit('switchTo', {channelId: null, customerId: null})
            }
            ably.updatePresenceEvents(channelId, 'leave')
            dispatch('message/removeChat', {channelId}, {root: true})
            dispatch('pastConsultation/addToPastConsultation', { consult: patient }, { root: true })
            dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
            // window.location.reload()
          }
        } else {
          dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        }
      })
    } else if (status === 'FAILURE') {
      consultationRequestAPI.endIncomplete(patient.consultationRequest.consultationRequestId, reasons).then(response => {
        if (response.status === 200 || response.status === 204) {
          commit('remove', channelId)
          if (response.body.status === 'error') {
            Vue.$toast.open({
              message: response.body.message,
              type: 'error',
              position: 'top',
              queue: false
            })
            commit('switchTo', {channelId: null, customerId: null})
          } else if (state.activeConsults.length > 0) {
            commit('switchTo', {channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId})
            dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
          } else {
            commit('switchTo', {channelId: null, customerId: null})
            dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
          }
          ably.updatePresenceEvents(channelId, 'leave')
          dispatch('message/removeChat', { channelId }, { root: true })
          dispatch('pastConsultation/addToPastConsultation', { consult: patient }, { root: true })
        } else {
          dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        }
      })
    }
  },

  fetchCustomerProfile ({commit, state}, {customerId, channelId}) {
    customerApi.getCustomerDetails(customerId).then(response => {
      if (response.status === 200) {
        commit('updateCustomerDetails', {channelId: channelId, customerDetails: response.body.customer})
      }
    })
  },

  switchTo ({commit, dispatch, state, rootState}, {channelId, customerId, isNewPatient = false}) {
    commit('switchTo', {channelId: channelId, customerId: customerId})
    if (channelId !== null && customerId !== null) {
      dispatch('message/setUpMessages', {channelId: channelId, customerId: customerId, isNewPatient: isNewPatient}, {root: true})
      dispatch('fetchCustomerProfile', {customerId: customerId, channelId: channelId})
    }
  },

  sendDoctorTyping ({ state, commit }, isTyping) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    if (patient) {
      ably.updatePresenceEvents(state.activeChannelId, 'update', { isTyping: isTyping, lastReadMessage: patient.lastReadMsg, deliveredMessage: patient.lastReceivedMsg, consultation_request_id: patient.consultationRequest.consultationRequestId })
    }
  },

  storeMessage ({state, commit}, message) {
    commit('storeMessage', {message})
  },

  receiveCustomerTyping ({ commit, state }, {channelId, isTyping}) {
    commit('setCustomerTyping', {channelId: channelId, typing: isTyping})
  },

  updateIsOnline ({commit, state}, {channelId, status}) {
    commit('togglePatientAvailability', {channelId: channelId, status: status})
  },

  ablyEnabled ({commit, state}, {channelId, status}) {
    commit('updateAblyChannelStatus', {channelId, status})
  },

  updateRecommendedTests ({commit, state}, data) {
    commit('updateRecommendedTests', data)
  },

  transferToDoctor ({commit, state}, {doctorId}) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    let channelId = patient.channelId
    consultationAPI.transferToNewDoctor(doctorId, patient.consultationRequest.consultationRequestId).then(response => {
      if (response.status === 200 && response.body.msg === 'Success') {
        commit('remove', channelId)
        if (state.activeConsults.length > 0) {
          commit('switchTo', {channelId: state.activeConsults[0].channelId, customerId: state.activeConsults[0].customerId})
        } else {
          commit('switchTo', {channelId: null, customerId: null})
        }
        ably.updatePresenceEvents(channelId, 'leave')
      }
    })
  },

  previewPrescription ({commit, state}, {data}) {
    prescriptionAPI.createPrescription(data, 'preview', state.activeChannelId).then(response => {
      if (response.status === 200) {
        window.open(response.body.prescription_url, '_blank')
      }
    })
  },

  updateHealthParameters ({commit, state, dispatch}, data) {
    HealthParameters.updateHealthParameters(data, state.activeCustomerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeChannelId, healthParameters: response.body.customer_health_parameters })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  updateGeneralParameters ({commit, state, dispatch}, data) {
    HealthParameters.updateGeneralParameters({gender: data.gender, date_of_birth: data.date_of_birth}, state.activeCustomerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (Object.keys(response.body).length > 0) {
          commit('updateCustomerDetails', { channelId: state.activeChannelId, customerDetails: {gender: response.body.gender, date_of_birth: response.body.date_of_birth} })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
    HealthParameters.updateHealthParameters({blood_group: data.blood_group}, state.activeCustomerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeChannelId, healthParameters: response.body.customer_health_parameters })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  updateMedication ({commit, state}, data) {
    commit('updateMedication', {channelId: state.activeChannelId, prescribedDrugs: data.prescribedDrugs})
  },

  updateCurrentMedication ({commit, state, dispatch}, medications) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    medicationsAPI.update(patient.customerId, medications).then(resp => {
      if (resp.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        commit('updateCurrentMedication', {channelId: state.activeChannelId, medications: resp.body.medications})
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  updateConsultation ({ commit, state, dispatch }, data) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    if (patient.consultation.consultationId) {
      summary.saveSummaryDetails(data, patient.consultation.consultationId).then(response => {
        if (response.status === 200) {
          dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
          commit('updateConsultation', { channelId: state.activeChannelId, consultation: response.body.consultation })
        } else {
          dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        }
      })
    } else if (patient) {
      if (Object.keys(data)[0] === 'chief_compliant') {
        data.customer_id = state.activeCustomerId
        data.consultation_request_id = patient.consultationRequest.consultationRequestId
        dispatch('createConsultation', data)
      } else {
        Vue.$toast.open({
          message: `Please add Chief complaint to create consultation`,
          type: 'error',
          position: 'top',
          queue: false
        })
        commit('updateConsultation', {channelId: state.activeChannelId, consultation: {}})
      }
    }
  },

  createConsultation ({ commit, state, dispatch }, data) {
    consultationAPI.create(data).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        commit('setupNewConsultation', { channelId: state.activeChannelId, consultation: response.body.consultation })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  sendSummary ({ commit, state, dispatch }, data) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    summary.sendSummary(patient.consultation.consultationId, data.componentKey).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  summaryNotNeeded ({ commit, state, dispatch }, data) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    summary.summaryNotNeeded(patient.consultation.consultationId, data.componentKey).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  uploadDocuments ({ commit, state, dispatch }, formData) {
    labDocument.uploadDocuments(formData).then(response => {
      if (response.status === 200) {
        // if (response.body.lab_reports) {
        commit('updateDocuments', {channelId: state.activeChannelId, data: response.body})
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        // } else if (response.body.prescriptions) {
        //   commit('updatePrescriptions', {channelId: state.activeChannelId, data: response.body.prescriptions})
        // }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },
  receivedDocumentUpdate ({ commit, state }, data) {
    let report = {
      id: data.message.payload.id,
      name: data.message.payload.file_name,
      date: new Date(Number(data.message.uniqueId))
    }
    commit('updateDocuments', {channelId: data.channelId, data: [report]})
  },
  storeLabTests ({state, commit}, { tests, customerId }) {
    commit('storeLabTests', {tests, customerId})
  },
  storeDrugs ({state, commit}, {drugs, channelId, isAdding}) {
    commit('storeDrugs', {drugs, channelId, isAdding})
  },
  removeDrugs ({state, commit}, {customerId}) {
    commit('removeDrugs', {customerId})
  }
}

// Mutations
const mutations = {
  setUpDetails (state, details) {
    state.activeConsults = []
    state.activeCustomerId = null
    state.activeChannelId = null
    for (let i = 0; i < details.length; i++) {
      let consult = {
        ablyEnabled: false,
        channelId: details[i].channel_id,
        customerId: details[i].customer_id,
        name: details[i].customer_name,
        isFamilyDoctor: details[i].is_family_doctor,
        familyDoctor: {id: details[i].family_doctor.id, name: details[i].family_doctor.name},
        accepted_at: details[i].accepted_at,
        consultationRequest: {
          consultationRequestId: details[i].consultation_request.consultation_request_id,
          chiefComplaint: details[i].consultation_request.chief_complaint,
          duration: details[i].consultation_request.duration,
          status: details[i].consultation_request.request_status,
          request_type: details[i].consultation_request.request_type,
          date: details[i].consultation_request.date
        },
        consultation: {
          chiefComplaint: details[i].consultation.chief_complaint,
          consultationId: details[i].consultation.consultation_id,
          provisionalDiagnosis: details[i].consultation.provisional_diagnois,
          summaryNotes: details[i].consultation.summary,
          date: details[i].consultation.date,
          summary_status: details[i].consultation.summary_status,
          prescribedDrugs: details[i].consultation.prescribed_drugs,
          recommendedTests: details[i].consultation.recommended_tests,
          followupReminders: details[i].consultation.followup_reminders
        },
        isCustomerTyping: false,
        isDoctorTyping: false,
        isOnline: false,
        details: {
          consultations: {},
          bmi: {},
          documents: [],
          medications: [],
          notifications: [],
          health_parameters: {},
          health_risks: {},
          lab_tests: [],
          medical_history: {},
          prescriptions: [],
          tags: [],
          wellness_score: {}
        },
        guardian_ek_id: ''
      }
      state.activeConsults.push(consult)
      state.initiated = true
      ably.subscribeToChannel(details[i].channel_id)
    }
  },

  remove (state, channelId) {
    let consult = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(consult)
    if (index > -1) {
      if (state.activeConsults.length > 1) {
        state.activeConsults.splice(index, 1)
      } else {
        state.activeConsults.splice(index, 1)
        state.activeConsults = []
      }
    }
  },

  setupNewConsultation (state, { channelId, consultation }) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      state.activeConsults[index].consultation.chiefComplaint = consultation.chief_compliant
      state.activeConsults[index].consultation.consultationId = consultation.id
    }
  },

  setCustomerTyping (state, options) {
    let consult = state.activeConsults.find(function (ele) {
      return (ele.channelId === options.channelId)
    })
    let index = state.activeConsults.indexOf(consult)
    if (index > -1) {
      state.activeConsults[index].isCustomerTyping = options.typing
    }
  },

  switchTo (state, {channelId, customerId}) {
    state.activeChannelId = channelId
    state.activeCustomerId = customerId
    let index = state.messages.findIndex((msg) => msg.channelId === channelId)
    if (index === -1) {
      state.inputMessage = ''
    } else {
      state.inputMessage = state.messages[index].message
    }
  },

  updateInputMessage (state, {channelId}) {
    // state.inputMessage = ''
    let updatedMesssages = state.messages.filter((msg) => {
      if (msg.channelId !== channelId) {
        return msg
      }
    })
    state.messages = updatedMesssages
  },

  addToActiveConsults (state, { request, consultation }) {
    let consult = {
      ablyEnabled: false,
      channelId: request.channelId,
      customerId: request.customer_id,
      name: request.customer_name,
      isFamilyDoctor: request.isFamilyDoctor,
      accepted_at: Date.now(),
      consultationRequest: {
        consultationRequestId: request.consultationRequestId,
        chiefComplaint: request.chiefComplaint,
        duration: request.duration,
        status: request.status,
        request_type: request.request_type,
        date: request.time
      },
      consultation: {
        chiefComplaint: consultation.chief_compliant,
        consultationId: consultation.id,
        provisionalDiagnosis: consultation.provisional_diagnois,
        status: consultation.summary_notes,
        date: consultation.date ? consultation.date : moment(consultation.created_at).format('DD MMM YYYY'),
        summary_status: consultation.summary_status,
        prescribedDrugs: [],
        recommendedTests: [],
        followupReminders: []
      },
      isCustomerTyping: false,
      isDoctorTyping: false,
      isOnline: true,
      details: {
        consultations: {},
        bmi: {},
        documents: [],
        medications: [],
        notifications: [],
        health_parameters: {},
        health_risks: {},
        lab_tests: [],
        medical_history: {},
        prescriptions: [],
        tags: [],
        wellness_score: {}
      },
      guardian_ek_id: ''
    }
    if (!request.isFamilyDoctor && request.familyDoctor) {
      consult.familyDoctor = {id: request.familyDoctor.id, name: request.familyDoctor.name}
    }
    state.activeConsults.unshift(consult)
    state.activeCustomerId = request.customer_id
    state.activeChannelId = request.channelId
    ably.updatePatientStatus(request.channelId)
  },

  addQueryToActiveConsults (state, { request, consultation }) {
    let consult = state.activeConsults.find(function (ele) {
      return (ele.channelId === request.channelId)
    })
    if (!consult) {
      let newConsult = {
        ablyEnabled: false,
        channelId: request.channelId,
        customerId: request.customer_id,
        name: request.customer_name,
        isFamilyDoctor: request.isFamilyDoctor,
        accepted_at: new Date(),
        consultationRequest: {
          consultationRequestId: request.consultationRequestId,
          chiefComplaint: request.chiefComplaint,
          duration: request.duration,
          status: request.status,
          request_type: request.request_type,
          date: request.time
        },
        consultation: {
          chiefComplaint: '',
          consultationId: null,
          provisionalDiagnosis: '',
          status: '',
          date: '',
          summary_status: '',
          prescribedDrugs: [],
          recommendedTests: [],
          followupReminders: []
        },
        isCustomerTyping: false,
        isDoctorTyping: false,
        isOnline: true,
        details: {
          consultations: {},
          bmi: {},
          documents: [],
          medications: [],
          notifications: [],
          health_parameters: {},
          health_risks: {},
          lab_tests: [],
          medical_history: {},
          prescriptions: [],
          tags: [],
          wellness_score: {}
        },
        guardian_ek_id: ''
      }
      if (!request.isFamilyDoctor) {
        newConsult.familyDoctor = {id: request.familyDoctor.id, name: request.familyDoctor.name}
      }
      state.activeConsults.unshift(newConsult)
      state.activeCustomerId = request.customer_id
      state.activeChannelId = request.channelId
      ably.updatePatientStatus(request.channelId)
    }
  },

  // Updates Customer Details
  updateCustomerDetails (state, {channelId, customerDetails}) {
    let consult = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(consult)
    if (index > -1) {
      if (Object.keys(customerDetails).length === 2) {
        state.activeConsults[index].details.date_of_birth = customerDetails.date_of_birth
        state.activeConsults[index].details.gender = customerDetails.gender
        state.activeConsults[index].guardian_ek_id = customerDetails.guardian_ek_id
      } else {
        state.activeConsults[index].details = customerDetails
        state.activeConsults[index].guardian_ek_id = customerDetails.guardian_ek_id
      }
    }
    ably.updatePatientStatus(channelId)
  },

  updateRecommendedTests (state, data) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === state.activeChannelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      state.activeConsults[index].consultation.recommendedTests = data
    }
  },

  // Changes the Patient availability status to offline/online
  togglePatientAvailability (state, {channelId, status}) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      if (status === true) {
        patient.isOnline = true
      } else {
        patient.isOnline = false
      }
      state.activeConsults.splice(index, 1, patient)
    }
  },

  updateDocuments (state, { channelId, data }) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      state.activeConsults[index].details.documents.push(data)
    }
  },

  // updatePrescriptions (state, { channelId, data }) {
  //   let patient = state.activeConsults.find(function (ele) {
  //     return (ele.channelId === channelId)
  //   })

  //   let index = state.activeConsults.indexOf(patient)
  //   if (index > -1) {
  //     state.activeConsults[index].details.prescriptions = state.activeConsults[index].details.prescriptions.concat(data)
  //   }
  // },

  updateHealthParameter (state, { channelId, healthParameters }) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      healthParameters.map(function (param) {
        state.activeConsults[index].details.health_parameters[param.question_tag] = param.result
        if (param.question_tag === 'height') {
          let answer = convertHeightToFeetInches(param.result)
          state.activeConsults[index].details.health_parameters['feet'] = answer[0]
          state.activeConsults[index].details.health_parameters['inches'] = answer[1]
        }
      })
    }
  },

  updateMedication (state, { channelId, prescribedDrugs }) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      state.activeConsults[index].consultation.prescribedDrugs = prescribedDrugs
    }
  },

  updateCurrentMedication (state, { channelId, medications }) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      state.activeConsults[index].details.medications = medications
    }
  },

  updateConsultation (state, { channelId, consultation }) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })

    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      state.activeConsults[index].consultation.chiefComplaint = consultation.chief_compliant
      state.activeConsults[index].consultation.provisionalDiagnosis = consultation.provisional_diagnois
      state.activeConsults[index].consultation.summaryNotes = consultation.summary_notes
    }
  },

  updateAblyChannelStatus (state, { channelId, status }) {
    let patient = state.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeConsults.indexOf(patient)
    if (index > -1) {
      patient.ablyEnabled = status
      state.activeConsults.splice(index, 1, patient)
    }
  },

  storeMessage (state, { message }) {
    let index = state.messages.findIndex((msg) => msg.channelId === message.channelId)
    let messages = state.messages
    if (index === -1) {
      messages.push(message)
    } else {
      messages[index] = message
      state.inputMessage = message
    }
    // Logging for jumbled messages in production
    // Temporary code to capture the store message
    if (message.channelId !== state.activeChannelId || state.activeChannelId !== state.activeCustomerId && message.length > 0) {
      let maskedMessage = ''
      maskedMessage = '*'.repeat(Math.max(0, message.length - 4)) + message.slice(-4)
      Sentry.setUser({ id: state.activeChannelId })
      Sentry.captureMessage('Store Message', {
        level: 'info',
        tags: { event_name: 'store_message' },
        extra: {
          msgChannelId: message.channelId,
          activeChannelId: state.activeChannelId,
          index: index,
          message: maskedMessage,
          activeCustomerId: state.activeCustomerId
        }
      })
    }
    state.messages = messages
  },

  storeLabTests (state, { tests, customerId }) {
    let index = state.selectedTests.findIndex((test) => test.customerId === customerId)
    let selectedLabTests = {}
    let selectedTests = state.selectedTests
    if (index > -1) {
      state.selectedTests[index].tests = tests
    } else {
      selectedLabTests = {
        customerId: customerId,
        tests: tests
      }
      selectedTests.push(selectedLabTests)
      state.selectedTests = selectedTests
    }
  },

  storeDrugs (state, { drugs, channelId, isAdding }) {
    let index = state.selectedDrugs.findIndex((drug) => drug.customerId === channelId)
    let selectedMedications = {}
    let selectedDrugs = state.selectedDrugs
    if (index > -1) {
      state.selectedDrugs[index].drugs = drugs
      state.selectedDrugs[index].isAdding = isAdding
    } else {
      selectedMedications = {
        customerId: channelId,
        drugs: drugs,
        isAdding: isAdding
      }
      selectedDrugs.push(selectedMedications)
      state.selectedDrugs = selectedDrugs
    }
  },

  removeDrugs (state, {customerId}) {
    let index = state.selectedDrugs.findIndex((drug) => drug.customerId === customerId)
    state.selectedTests = state.selectedTests.filter((ele) => ele.customerId !== customerId)
    if (index > -1) {
      state.selectedDrugs = state.selectedDrugs.filter((ele) => ele.customerId !== customerId)
      // delete state.selectedDrugs[index]
      state.drugs = state.drugs.filter((ele) => ele.customerId !== customerId)
    }
  },

  storeCurrentDrugs (state, { drug, customerId }) {
    if (drug.frequency === 'PRN/SOS') {
      drug.frequency = `PRN/SOS (Only if symptoms are there) ${drug.frequency_unit}`
    } else if (drug.frequency_unit !== null) {
      drug.frequency = `${drug.frequency} a ${drug.frequency_unit}`
    }
    drug.route = drug.route ? drug.route.trim() : null
    drug.instructions = drug.instructions ? drug.instructions.trim() : null
    let index = state.drugs.findIndex((ele) => ele.customerId === customerId)
    if (index > -1) {
      state.drugs[index].drugs.push(drug)
    } else {
      let drugs = {
        drugs: [drug],
        customerId: customerId
      }
      state.drugs.push(drugs)
    }
  },

  reset (state) {
    state = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/consultation.js